import logo from "../assets/showroom360-logo.png";
import { useSettings } from "../lib/settings";
import { useT } from "../lib/i18n";

import { tr } from "../lib/i18n";
/** Single-colour Showroom 360 mark, tinted via CSS (.pb-mark); sidebar follows the secondary tone. */
export default function PoweredBy({ variant = "light", className = "" }) {
  const { settings } = useSettings();
  const { t } = useT();
  if (settings?.powered_by_enabled === false) return null;
  const href = settings?.powered_by_url || "https://wafa.om";

  const v = `pb-${variant}`;

  return (
    <a href={href} target="_blank" rel="noopener noreferrer"
      aria-label={tr("x.powered_by_showroom_360")} data-testid="powered-by-link"
      className={`inline-flex items-center gap-2 ${className}`}>
      <span className={`pb-label ${v} text-[10px] tracking-[0.18em] uppercase font-medium`}>
        {t("powered.by")}
      </span>
      <img src={logo} alt="Showroom 360" className={`pb-mark ${v}`} style={{ height: 22, width: "auto" }} />
    </a>
  );
}
